export const contributors = (root) => root
